import React, { useEffect, useState, MouseEvent } from 'react'
import { Select2, ItemListPredicate } from '@blueprintjs/select'
import { MenuItem, Position, Checkbox } from '@blueprintjs/core'
import { Button, Flex, HighlightedText } from '@ui'
import { IUIButtonProps } from '@ui/buttons/Button'
import fuzzy from 'fuzzaldrin-plus'
import { get } from 'lodash'
import { IGlobalMapObject } from '@api'
import api from '@api'

interface GlobalMapObjectSelectProps {
  value: React.ReactNode
  btnText?: string
  itemDisabled?: (item: IGlobalMapObject) => boolean
  onChange: (item: IGlobalMapObject) => void
  buttonProps?: IUIButtonProps
  multi?: boolean
}

const BPSelect = Select2<IGlobalMapObject>

export default function GlobalMapObjectSelect({
  value,
  btnText,
  itemDisabled,
  onChange,
  buttonProps,
  multi,
}: GlobalMapObjectSelectProps) {
  const [globalMapObjects, setGlobalMapObjects] = useState<IGlobalMapObject[]>([])

  useEffect(() => {
    api.company.globalMapObjects().then((globalMapObjects) => {
      setGlobalMapObjects(globalMapObjects)
    })
  }, [])

  return (
    <BPSelect
      resetOnSelect
      popoverProps={{
        minimal: true,
        position: Position.BOTTOM,
      }}
      noResults={<MenuItem disabled text="No results" />}
      items={globalMapObjects}
      itemListPredicate={filterCostCenters}
      itemRenderer={(mapObject, { handleClick, modifiers, query }) => (
        <MenuItem
          key={mapObject.id}
          active={modifiers.active}
          onClick={(e: MouseEvent<HTMLElement>) => {
            if (multi) {
              e.preventDefault()
              onChange(mapObject)
              return
            }
            handleClick(e)
          }}
          text={
            <Flex align="center">
              {multi && <Checkbox checked={itemDisabled && itemDisabled(mapObject)} />}
              <HighlightedText text={mapObject.name} query={query} />
            </Flex>
          }
        />
      )}
      onItemSelect={onChange}
    >
      <Button
        {...buttonProps}
        text={value ? value : btnText || 'Select'}
        rightIconName={!get(buttonProps, 'iconName') && !value ? 'chevron-down' : undefined}
      />
    </BPSelect>
  )
}

const filterCostCenters: ItemListPredicate<IGlobalMapObject> = (query, globalMapObjects) => {
  return query ? fuzzy.filter(globalMapObjects, query, { key: 'name' }) : globalMapObjects
}
